import { render, staticRenderFns } from "./bookingOrder.vue?vue&type=template&id=b0d7cdd6&scoped=true"
import script from "./bookingOrder.vue?vue&type=script&lang=js"
export * from "./bookingOrder.vue?vue&type=script&lang=js"
import style0 from "./bookingOrder.vue?vue&type=style&index=0&id=b0d7cdd6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d7cdd6",
  null
  
)

export default component.exports